export { default as FlexibleEditpageLoader } from './flexible-edit-page-loader';
